import { render, staticRenderFns } from "./CompanyInfoCard.vue?vue&type=template&id=11649090&scoped=true"
import script from "./CompanyInfoCard.vue?vue&type=script&lang=js"
export * from "./CompanyInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoCard.vue?vue&type=style&index=0&id=11649090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11649090",
  null
  
)

export default component.exports